import { FunctionComponent, useEffect, useState } from "react";
import { LoadingSpinner, PageContainer, PageTitle } from "src/components/generic";
import { youtube } from "src/utils";
import SquareTile from "src/components/generic/tiles/SquareTile";
import TopNav from "src/components/navigation/TopNav";
import Carousel from "src/components/generic/Carousel";
import YouTubePlayer from "src/components/website/Resources/YouTubePlayer";


const YouTubeVideos: FunctionComponent = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');
    const [videos, setVideos] = useState<Record<any, any>[] | null>(null)

    const fetchVideos = async () => {
        try {
            const result = await youtube.fetchAllVideos();
         
            setVideos(result);
        } catch (error: any) {
            setError(error?.message || 'Failed to Fetch Videos');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!videos) fetchVideos();
    }, []);

    if(loading) return <LoadingSpinner />
    return (
        <PageContainer>
            <TopNav />
            <PageTitle title="Videos" />

            <SquareTile title="About ClientVitals">
                <Carousel visibleItems={2}>
                    {
                        videos?.map((video: Record<any, any>) => (
                            <YouTubePlayer
                                key={video.publishTime}
                                title={video.title}
                                url={video.embedUrl}
                                styles="w-[1080px] h-[920px]"
                            />
                         ))
                    }
                </Carousel>
            </SquareTile>
        </PageContainer>
    )
}

export default YouTubeVideos;